export default class FSAModel {
  constructor(graphElements) {
    this.elements = graphElements;
  }
}
